import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import {
  dblclickTooltipDef,
  defaultColumn,
  DELETE_RECORD_LABEL,
  grid_widths_map,
  rolesModuleName,
  subModuleName,
} from '@piqet-angular/shared';
import { right } from '@popperjs/core';
import {
  AdministratorFacade,
  Helper,
  getRolesAndPermission,
  nameFormatter,
  abbreviateCountryStr,
} from '@piqet-angular/data';
import { Subject } from 'rxjs';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
@Injectable({
  providedIn: 'root',
})
export class OtherCountryIndetifiersDataGridService {
  countryIndetifiersDataPayload: any;
  event: any;

  editCountryIndetifiersData = new Subject<[any, any, any, any]>();
  countryIndetifiersObservable$ = this.editCountryIndetifiersData.asObservable();

  deleteCountryIndetifiersData = new Subject<[any, any, any, any]>();
  countryIndetifiersDeleteObservable$ = this.deleteCountryIndetifiersData.asObservable();

  constructor(private AdministratorFacade: AdministratorFacade, private swalService: SwalService) {}

  getCountryIndetifiersDataColumn(): ColDef[] {
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'CountryCode',
      headerName: 'Country code',
      field: 'countryCode',
      cellClass: 'my-permission-cursor-pointer',
      // sort: 'asc',
      filter: 'agTextColumnFilter',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      editable: false,
      cellRenderer: (params: any, pathName: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        cellElement.innerHTML = `${cellValue}`;
        cellElement.style.cursor = 'pointer';
        cellElement.style.textDecoration = 'underline';
        cellElement.title = dblclickTooltipDef;
        cellElement.addEventListener('dblclick', () => {
          if (
            params.columnApi.columnModel.columnDefs[
              params.columnApi.columnModel.columnDefs.length - 1
            ].cellRendererParams?.showEdit
          )
            this.editCountryIndetifiersData.next([
              params.data.id,
              'Review country identifiers detail',
              location.href.split('/')[7],
              params.data.associatedRegionId,
            ]);
        });
        return cellElement;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'CountryName',
      headerName: 'Country',
      field: 'countryName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      filter: 'agTextColumnFilter',
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      editable: false,
      valueFormatter: (params: any) => abbreviateCountryStr(params.data?.countryName),
    });

    colDef.push({
      ...defaultColumn,
      colId: 'RegionCode',
      headerName: 'Region code',
      field: 'regionCode',
      filter: 'agTextColumnFilter',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      editable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'RegionName',
      headerName: 'Region name',
      field: 'regionName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      filter: 'agTextColumnFilter',
      resizable: false,
      editable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Actions',
      headerName: 'Actions',
      field: 'actions',
      sortable: false,
      cellRendererParams: {
        showCopy: false,
        showEdit: this.isAccess() ? this.isAccess().isEdit : true,
        showDelete: this.isAccess() ? this.isAccess().isDelete : true,
        deleteData: (data: any, pathName: any) => {
          this.deleteCountryIdetifierDataConfirmation(
            data.id,
            data.associatedRegionId,
            '/CountryIndetifiers/DeleteCountryIndetifiers?id',
            pathName
          );
        },
        editData: (data: any, pathName: any) => {
          this.editCountryIndetifiersData.next([
            data.id,
            'Review country identifiers detail',
            pathName,
            data.associatedRegionId,
          ]);
        },
      },
      maxWidth: grid_widths_map.sm_column_xs,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'actionRenderer',
      lockVisible: true,
      lockPosition: right,
      resizable: false,
    });
    return colDef;
  }

  isAccess = () => {
    return getRolesAndPermission(
      rolesModuleName.DataManageOtherDataCountryIdentifier,
      subModuleName.otherDataModule
    );
  };

  deleteCountryIdetifierDataConfirmation(data: any, customType: any, pathName: any, id: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.deleteCountryIndetifiersData.next([data, customType, pathName, id]);
      }
    });
  }
  getPayload(searchData: any, sortColumnState?: any, event?: any) {
    if (event) {
      this.event = event;
    }
    const currentPage = this.event?.goToPage
      ? this.event.goToPage
      : this.event?.next
      ? this.event.currentPage + 1
      : this.event?.prev
      ? this.event?.currentPage - 1
      : this.event?.gridApi?.paginationGetCurrentPage() + 1;
    const pageSize = this.event?.gridApi.paginationGetPageSize();
    const startCount = pageSize * (currentPage - 1);

    const columns = this.getCountryIndetifiersDataColumn()
      .map((item: any) => {
        return {
          searchable: true,
          name: item.colId,
          orderable: true,
          data: item.colId,
        };
      })
      .filter(value => value?.name != 'Actions');

    return (this.countryIndetifiersDataPayload = {
      search: {
        columnNameList: [],
        value: searchData || '',
      },
      columns: columns,
      order: [
        {
          columnName: sortColumnState?.columnName || 'countryCode',
          dir:
            sortColumnState?.dir[0].toUpperCase() + sortColumnState?.dir.substr(1).toLowerCase() ||
            'Asc',
        },
      ],
      start: startCount || 0,
      length: pageSize == Number(this.event?.totalRecord) ? Number('-1') : pageSize || 10,
      draw: currentPage || 1,
    });
  }
}
